<template>
  <div>
    <b-row>
      <b-col
        cols="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 385px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <span style="font-size:20px; color: #fff;">ปริมาณจราจรในสายทาง</span>
          </div>
          <div>
            <app-echart-bar
              :option-data="optionBar"
              style="width:auto; height:300px; margin-top: 10px"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard,
// BCard, BCardText,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEchartBar from '@core/components/charts/echart/AppEchartBarCounting.vue'
import * as echarts from 'echarts'

export default {
  components: {
    AppEchartBar,
    BRow,
    BCol,
    BCard,

  },
  data() {
    return {
      optionBar: {
        xAxisData: [],
        series: [
          {
            name: 'ทั้งหมด',
            type: 'bar',
            stack: 'Total',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#99FBCA',
              },
              {
                offset: 1,
                color: '#00B058',
              },
              ]),
              barBorderRadius: [4, 4, 0, 0],
            },
            data: [],
            barMaxWidth: '40%',
            barMinWidth: '10px',
          },
        ],
      },
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getBarChart()
    this.interval = setInterval(() => {
      this.getBarChart()
    }, 300000)
  },
  methods: {
    getBarChart() {
      axios
        .post('/getBarCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisData = []
          this.optionBar.xAxisData.splice(0)
          this.optionBar.series[0].data.splice(0)
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.optionBar.xAxisData.push(value.Date_Name)
            this.optionBar.series[0].data.push(value.Total)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>

</style>
